import React, {ReactNode} from "react";
import {cx} from "@emotion/css";

import "./Spinner.scss";
import {styled} from "@reside/ui";

type Props = Readonly<{
  relative?: boolean;
  backdrop?: boolean;
  icon?: ReactNode;
}>;

export const spinnerIcon = (
  <div className="spinner">
    <div />
    <div />
  </div>
);

const SpinnerContainer = styled.div`
  .spinner {
    div {
      border-color: ${({theme}) => theme.color.primary};
    }
  }
`;

export const Spinner = ({relative, backdrop, icon}: Props) => (
  <SpinnerContainer
    className={cx("spinner-container", {
      "is-relative": relative,
      "on-backdrop": backdrop,
    })}
  >
    {icon}
  </SpinnerContainer>
);

Spinner.defaultProps = {
  icon: spinnerIcon,
};
